idm.registerPageInitFunction(function () {
  function formatField() {
    var field = $(this),
      value = field.val(),
      mask = field.data("mask"),
      maskNumbers = mask.match(/0/g),
      valueNumbers = value.match(/(\d)/g) || "",
      formattedValue;
    if (value && maskNumbers.length === valueNumbers.length) {
      formattedValue = mask.replace(/0/g, function () {
        return valueNumbers.shift() || "";
      });
      field.val(formattedValue);
      field.valid();
    }
  }

  $("input[data-mask]").blur(formatField);
});
